import { baseReducer } from '../core/base-reducer';

import { SET_SHIPPY_PENDING_PREFILL, CLEAR_SHIPPY_PENDING_PREFILL } from './shippy.actions';
import { namespace as shippyNamespace } from './shippy.reducer.metadata';

const initialState = {
  pendingPrefill: null,
};

const actionHandlerMap = {
  [SET_SHIPPY_PENDING_PREFILL]: (_state: typeof initialState, { prefill }: { prefill: unknown }) => ({
    ...initialState,
    pendingPrefill: prefill,
  }),
  [CLEAR_SHIPPY_PENDING_PREFILL]: () => initialState,
};

export const shippyReducer = baseReducer(initialState, actionHandlerMap);
export const namespace = shippyNamespace;
